require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
// import $bus from '@/Event';
import mitt from 'mitt';
const emitter = mitt();
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia'

import { InertiaProgress } from '@inertiajs/progress';
const el = document.getElementById('app');
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
// import Vue3TelInput from 'vue3-tel-input';
import VueTelInput from 'vue-tel-input'
// import 'vue3-tel-input/dist/vue3-tel-input.css';
import 'vue-tel-input/dist/vue-tel-input.css';
import colorPicker from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import VueCookies from 'vue3-cookies';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import infiniteScroll from 'vue3-infinite-scroll-good'
import 'v-calendar/dist/style.css';


const app = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => import(`./Pages/${name}`).then((res) => res.default).catch(err => {
                alert(err)
            }),
        }),
})
    .mixin({ methods: { route } })
    .use(InertiaPlugin)
    .use(VueSweetalert2)
    .use(VueTelInput)
    .use(colorPicker)
    .use(infiniteScroll)
    .use(VueCookies,{
    expireTimes: "100d",
    })
    .use(VueGoogleMaps, {
        load: {
            key: process.env.MIX_GOOGLE_MAPS_API_KEY,
            libraries:'places',
        },
    });
app.config.globalProperties.emitter = emitter;
app.mount(el);
Inertia.on('start', (event) => {
    // regex match against the url of campaigns (that is the search box) if not matched removed the search key input
    /**
     * const url1 = '/campaigns/f7cc15e2-cfe0-4f9f-9323-1cbebe2239b6';
const url2 = '/campaigns/f7cc15e2-cfe0-4f9f-9323-1cbebe2239b6/';
const url3 = '/campaigns/f7cc15e2-cfe0-4f9f-9323-1cbebe2239b6/some/optional/characters';

console.log(regex.test(url1)); // true
console.log(regex.test(url2)); // true
console.log(regex.test(url3)); // true
     */
    const regex = /^\/campaigns\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/?.*$/;
    const url = new URL(event.detail.visit.url, window.location.origin);
    const path = url.pathname;
    console.log({regex,url,path})
    if (!regex.test(path)) {
        console.log("found a match")
      setTimeout(() => {
        sessionStorage.removeItem('search_widgets');
      }, 1000);
    }
    console.log(`The route changed to ${event.detail.visit.url}`)
  })
InertiaProgress.init({ color: '#124664',showSpinner:false });
